import type { ISerialize } from '@/objects/ISerialize';

export abstract class SettingsBase implements ISerialize {
    static NAME_OF_CLASS: string; // This should be overridden in the child class
    public constructor() {}

    /**
     * Serialize the object to a JSON string
     * @returns A string representation of the object
     */
    public serialize(): string {
        return JSON.stringify(this);
    }

    /**
     * Deserialize the object from a JSON string
     * @param json The JSON string to deserialize
     * @returns The deserialized object as a plain object. This will be used as a constructor parameter in {@link useStoredSettings}
     */
    public deserialize(json: any): any {
        return JSON.parse(json);
    }
}
